let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Di82")).then(() => parcelRequire('6eQg4'));